import { render, staticRenderFns } from "./AppTermSummary.vue?vue&type=template&id=18147aec"
import script from "./AppTermSummary.vue?vue&type=script&lang=js"
export * from "./AppTermSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports